<template>
  <div data-module="hero">
    <div
      v-if="data.background.type === 'image'"
      class="background"
      :style="style" :class="{ 'stretch': data.stretch, 'constrain': data.constrain }"
    ></div>

    <div
      v-if="data.background.type === 'video'"
      class="background background--video"
      :class="{ 'stretch': data.stretch, 'constrain': data.constrain }"
    >
      <video autoplay muted loop playsinline :poster="data.background.poster">
        <source :src="data.background.src" />
        <img :src="data.background.poster" alt="Picture of Particle's logo on the wall">
      </video>
    </div>
    <div class="content">
      <h1 class="headline" data-type="title">{{data.headline}}</h1>
      <div data-ornament="circle" v-if="data.ornament" />
    </div>
    <template v-if="!data.constrain">
      <ScrollItem :id="`beginNavOverlay`" :offset="94">
        <div data-anchor="beginNavOverlay"></div>
      </ScrollItem>
    </template>
  </div>
</template>

<script>
// Module expects:
//  - `headline`: text string
//  - `background`: media element (acceptable formats: video, image, color)
export default {
  name: 'module_hero',
  props: ['data', 'window'],
  computed: {
    style: function() {
      if (this.data.background.type === 'image') {
        let background;
        const window = this.window;

        if (this.data.backgroundSet) {
          background = this.data.backgroundSet.find(function(bg) {
            return window.width < bg.max;
          });
        }
        if (background) {
          background = background.src;
        } else {
          background = this.data.background.image;
        }

        return {
          'background-image': `url('${background}')`,
        };
        // const background = [];
        // if (this.data.overlay) {
        //   const overlay = this.data.overlay;
        //   // set a default overlay:
        //   if (typeof overlay === 'boolean') {
        //     background.push(`linear-gradient(to bottom, rgba(0,0,0,0.4) 0%, rgba(0,0,0,0.4) 100%)`);
        //   }

        //   // TODO: lol let user decide
        // }
        // background.push(`url('${this.data.background.image}')`);

        // return {
        //   'background-image': background.join(),
        // };
      }

      return false;
    },
  },
};
</script>

<style lang="scss">
@import '~@/styles/_variables.scss';
@import '~@/styles/_mixins.scss';

[data-module="hero"] {
  @include mq($bp--tablet, up) {
    margin-top: rem(94px);
  }

  @include mq($bp--tablet, down) {
    margin-top: rem(60px);
  }

  .background {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;

    background-size: cover;
    background-position: bottom center;
    background-repeat: no-repeat;

    &--video {
      background: black; //letterboxing fallback
    }
  }

  video {
    position: absolute;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .content {
    @include grid($subgrid: true);
  }

  .headline {
    grid-column: 1 / span 9;
    color: $color--primary-white;
  }

  [data-ornament="circle"] {
    position: absolute;
    top: 100%;
    left: 0;
    transform: translateY(-50%);

    margin: 0 $layout--gutter;

    width: 150px;

    @include createOrnament($type: circle);
  }

  [data-anchor="beginNavOverlay"] {
    position: absolute;
    bottom: 0;
  }

  @include mq($bp--mobile, down) {

    .content {
      margin: 0;
      grid-gap: 0;
      height: rem(350px);
      max-height: 75vh;
    }
    .headline {
      grid-column: 1 / span 11;
      margin: rem(280px) 0;
      font-size: rem(22px);
    }
  }

  @include mq($nbp--mobile, down) {
      .headline {
        grid-column: 1 / span 11;
        margin: rem(140px) 0;
        font-size: rem(30px);
      }
  }

  @include mq($bp--mobile, up) {
   height: rem(600px);
   max-height: 75vh;

    .content {
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
    }

    .headline {
      margin: 0 0 $component-spacer / 2 0;
    }
  }

  @include mq($bp--tablet, down) {
    // spacing for the nav bar
    margin-top: rem(60px);

    .headline {
      //margin-top: rem(175px);
      grid-column: 1 / span 9;

    }

    [data-ornament] {
      left: auto;
      right: 0;
      width: 100px;
    }
  }

  @include mq($bp--tablet, up) {
    .headline {
      margin: 0 0 $component-spacer 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/hero.vue